import { RegisterProdStackService } from 'types/services';
import { RESIDENT_COUNTRY_CODE } from 'utils/constants';
import { HTTPConnectionError, UnexpectedError } from 'utils/errors';
import { m8API } from '../m8';
import { M8PartnerDTO } from '../types';
import { normalizeOrgStaffCount } from '../utils/normalizeOrgStaffCount';

export const registerProdStack: RegisterProdStackService = async (params) => {
  const { orgInfoFormValues, personalInfoFormValues } = params;

  const partnerCode = personalInfoFormValues.partnerCode.join('');

  let partner: null | M8PartnerDTO = null;

  if (partnerCode.length === 4) {
    partner = await m8API.user.getPartnerByCode({ partnerCode });
  }

  if (orgInfoFormValues.location === null) {
    throw new UnexpectedError();
  }

  await m8API.user
    .confirmDataAndGetTrial({
      firstName: personalInfoFormValues.firstName,
      lastName: personalInfoFormValues.lastName,
      middleName: personalInfoFormValues.middleName,
      organization: orgInfoFormValues.name,
      position: personalInfoFormValues.position,
      companySize: orgInfoFormValues.staffCount
        ? normalizeOrgStaffCount(orgInfoFormValues.staffCount).toCompanySize()
        : 'UNDEFINED',
      phone: personalInfoFormValues.phone,
      sex: 'MALE',
      country: orgInfoFormValues.location,
      resident: orgInfoFormValues.location === RESIDENT_COUNTRY_CODE,
      idPartner: partner ? partner.id : null,
    })
    .catch((error) => {
      if (error instanceof HTTPConnectionError) {
        // На iOS может возникать обрыв соединения
        // при сворачивании приложения с открытой страницей.
        return null;
      }

      throw error;
    });
};
